import { useParams } from 'next/navigation';

import { decodeSearchQuery } from '../queryEncoding';

export const useOriginalSearchQuery = () => {
  const searchParams = useParams() ?? {};

  return decodeSearchQuery(searchParams) ?? '';
};
